require('../../modules/es6.date.to-string')
var $toString = Date.prototype.toString;
module.exports = function toString(it){
  return $toString.call(it);
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/date/to-string.js
// module id = 225
// module chunks = 0